var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.876 22.5C7.08598 22.5 2.37598 17.79 2.37598 12C2.37598 6.21 7.08598 1.5 12.876 1.5C18.666 1.5 23.376 6.21 23.376 12C23.376 17.79 18.666 22.5 12.876 22.5ZM12.876 3C7.91098 3 3.87598 7.035 3.87598 12C3.87598 16.965 7.91098 21 12.876 21C17.841 21 21.876 16.965 21.876 12C21.876 7.035 17.841 3 12.876 3Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.876 15.75C15.741 15.75 15.606 15.72 15.486 15.645L11.736 13.395C11.625 13.3283 11.5333 13.2336 11.4701 13.1204C11.407 13.0073 11.3745 12.8796 11.376 12.75V6.75C11.376 6.33 11.706 6 12.126 6C12.546 6 12.876 6.33 12.876 6.75V12.33L16.266 14.355C16.4057 14.4406 16.5136 14.5694 16.5734 14.7218C16.6333 14.8742 16.6418 15.042 16.5977 15.1997C16.5536 15.3575 16.4593 15.4965 16.3291 15.5958C16.1989 15.6951 16.0398 15.7492 15.876 15.75Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.c0f5d07f7bd411b149c1b391a2e5e7b1.svg";
export { ForwardRef as ReactComponent };